import * as React from "react";
const SvgHubspot = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FF7A59",
  fillRule: "evenodd",
  d: "M16.143 16.574a3.08 3.08 0 0 1-3.086-3.078c0-1.7 1.381-3.078 3.086-3.078a3.08 3.08 0 0 1 3.085 3.078c0 1.7-1.381 3.078-3.085 3.078m.923-9.004V4.832a2.11 2.11 0 0 0 1.219-1.9v-.063c0-1.159-.95-2.106-2.11-2.106h-.064c-1.16 0-2.11.947-2.11 2.106v.063c0 .839.501 1.562 1.218 1.9V7.57a6 6 0 0 0-2.845 1.25L4.837 2.97c.05-.19.085-.386.085-.592A2.38 2.38 0 0 0 2.544 0 2.38 2.38 0 0 0 .161 2.372 2.38 2.38 0 0 0 2.538 4.75c.429 0 .826-.12 1.173-.318l7.413 5.753c-.63.95-1 2.087-1 3.311 0 1.282.406 2.467 1.092 3.442l-2.254 2.25a2 2 0 0 0-.56-.091c-1.08 0-1.956.874-1.956 1.951 0 1.078.876 1.952 1.957 1.952s1.956-.874 1.956-1.952c0-.195-.037-.38-.09-.557l2.23-2.225a6 6 0 0 0 3.644 1.234c3.323 0 6.018-2.688 6.018-6.004 0-3.002-2.21-5.482-5.095-5.926",
  clipRule: "evenodd"
}));
export default SvgHubspot;
//# sourceMappingURL=Hubspot.js.map